import { useState, useEffect } from "react"
import { AiOutlineDown } from "react-icons/ai";
import "./profileAdd.css"
import { FaTrashCan } from "react-icons/fa6";
import { FaPenToSquare } from "react-icons/fa6";
import { handleDeleteAddress, handleGetAddress, handlePushAddress, handleGetUser, handlUpdateAddress } from "../../requests/userRequests";
import { useGlobalContext } from "../../context";
import { Accordion } from 'rsuite';
import 'rsuite/Accordion/styles/index.css';
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

function ProfileAdd(props) {
    const user = useAuthUser()
    const { handleErr, setRoute, savedAddress, setSavedAddress } = useGlobalContext()
    useEffect(() => {
        setRoute(props.route)
    }, [])
    const states = [
        { placeHolder: "خراسان رضوی", value: "khorasanRazavi" },
        { placeHolder: "خراسان شمالی", value: "khorasanShomali" },
        { placeHolder: "خراسان جنوبی", value: "khorasanJonobi" },
        { placeHolder: "تهران", value: "tehran" },
        { placeHolder: "اصفهان", value: "esfahan" },
        { placeHolder: "شیراز", value: "shiraz" },
        { placeHolder: "تبریز", value: "tabriz" },
    ]
    const cities = [
        { placeHolder: ["مشهد", "فریمان"], value: "khorasanRazavi" },
        { placeHolder: ["بیرجند", "نهبندان"], value: "khorasanJonobi" },
        { placeHolder: ["شیروان", "بجنورد"], value: "khorasanShomali" },
        { placeHolder: ["تهران"], value: "tehran" },
        { placeHolder: ["اصفهان"], value: "esfahan" },
        { placeHolder: ["شیراز"], value: "shiraz" },
        { placeHolder: ["تبریز"], value: "tabriz" }
    ]
    const [stateOptions, setStateOptions] = useState(states)
    const [selectedAddress, setSelectedAddress] = useState(false)
    const [showState, setShowState] = useState(false)
    const [state, setState] = useState({ placeHolder: "خراسان رضوی", value: "khorasanRazavi" })
    const [searchState, setSearchState] = useState("")
    const [openAddress, setOpenAddress] = useState(false)
    const getCity = () => {
        const find = cities.find(item => item.value == state.value)
        return find.placeHolder
    }
    const [cityoptions, setCityOptions] = useState(getCity())
    const [showCity, setShowCity] = useState(false)
    const [city, setCity] = useState("انتخاب شهر")
    const [searchCity, setSearchCity] = useState("")
    const [address, setAddress] = useState({
        state: state.placeHolder,
        city,
        address: "",
        postCode: "",
        number: "",
        floor: "",
        transfreeFname: "",
        transfreeLname: "",
        transfreePhoneNumber: "",
        chosen: false
    })
    useEffect(async () => {
        const res = await handleGetAddress(user._id)
        setSavedAddress(res.address)
    }, [])
    console.log(savedAddress)
    const handleAddress = async () => {
        if (address.city == "" || address.city == "انتخاب شهر") {
            return handleErr("error", "شهر خود را انتخاب کنید")
        }
        if (address.address == "" || address.postCode == "" || address.number == "" || address.floor == "" || address.transfreeFname == "" || address.transfreeLname == "" || address.transfreePhoneNumber == "") {
            return handleErr("error", "مقادیر ستاره دار را پر کنید")
        }
        if (savedAddress.length >= 3) {
            return handleErr("error", "تعداد آدرس های شما به حداکثر رسیده است.")
        }
        for (let i = 0; i < savedAddress.length; i++) {
            if (address.postCode === savedAddress[i].postCode) {
                return handleErr("error", "این کدپستی قبلا ثبت شده")
            }
        }
        try {
            const res = await handlePushAddress(user._id, address)
            const res1 = await handleGetAddress(user._id)
            setSavedAddress(res1.address)
            return handleErr(res.type, res.massage)
        } catch (err) {
            console.log(err)
        }
    }
    const updateAddress = async () => {
        if (address.city == "" || address.city == "انتخاب شهر") {
            return handleErr("error", "شهر خود را انتخاب کنید")
        }
        if (address.address == "" || address.postCode == "" || address.number == "" || address.floor == "" || address.transfreeFname == "" || address.transfreeLname == "" || address.transfreePhoneNumber == "") {
            return handleErr("error", "مقادیر ستاره دار را پر کنید")
        }
        try {
            let newAdddress = savedAddress.map((item) => item.postCode == address.postCode ? address : item)
            const res = await handlUpdateAddress(user._id, newAdddress)
            const res1 = await handleGetAddress(user._id)
            setSavedAddress(res1.address)
            setSelectedAddress(false)
            setAddress(
                {
                    state: { placeHolder: "خراسان رضوی", value: "khorasanRazavi" },
                    city,
                    address: "",
                    postCode: "",
                    number: "",
                    floor: "",
                    transfreeFname: "",
                    transfreeLname: "",
                    transfreePhoneNumber: "",
                    chosen: false
                }
            )
            return handleErr(res.type, res.massage)
        } catch (err) {
            console.log(err)
        }
    }
    const handleChooseAddress = async (address) => {
        try {
            const updateAddress = savedAddress.map((item) => {
                if (item.postCode == address.postCode) {
                    return { ...item, chosen: true }
                } else {
                    return { ...item, chosen: false }
                }
            })
            await handlUpdateAddress(user._id, updateAddress)
            const res = await handleGetAddress(user._id)
            setSavedAddress(res.address)
        } catch (err) {
            console.log(err)
        }
    }
    const deleteAddress = async (postCode) => {
        const res = await handleDeleteAddress(user._id, postCode)
        const res1 = await handleGetAddress(user._id)
        setSavedAddress(res1.address)
        return handleErr(res.type, res.massage)
    }
    const getAddress = async (postalcode) => {
        const res = await handleGetUser(user._id)
        let addresses = res.address.filter((item) => item.postCode == postalcode)
        setAddress(addresses[0])
        setOpenAddress(true)
        setSelectedAddress(true)
    }
    useEffect(() => {
        setAddress({ ...address, state: state, city: city })
    }, [state, city])
    useEffect(() => {
        if (searchState == "") {
            return setStateOptions(states)
        } else {
            const search = states.filter(item => item.placeHolder.includes(searchState))
            setStateOptions(search)
        }
    }, [searchState])
    //--------------------------

    useEffect(() => {
        const find = cities.find((item) => item.value == state.value)
        setCityOptions(find.placeHolder)
    }, [state])
    useEffect(() => {
        if (searchCity == "") {
            return setCityOptions(getCity())
        } else {
            const search = cityoptions.filter(item => item.includes(searchCity))
            setCityOptions(search)
        }
    }, [searchCity])
    return (
        <div className="outlet-container">
            <div className="saved-address">
                <h2>آدرس های ذخیره شده</h2>
                <table>
                    <thead>
                        <tr>
                            <th>نام</th>
                            <th>تلفن</th>
                            <th>آدرس</th>
                            <th>کدپستی</th>
                            <th>عملیات</th>
                            {
                                props.route == "shipping" &&
                                <th>انتخاب</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            savedAddress &&
                            savedAddress.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{item.transfreeFname}</td>
                                        <td>{item.transfreePhoneNumber}</td>
                                        <td>{item.address}</td>
                                        <td>{item.postCode}</td>
                                        <td>
                                            <FaTrashCan size={25} color="crimson" onClick={() => deleteAddress(item.postCode)} />
                                            <FaPenToSquare size={25} color="green" onClick={() => getAddress(item.postCode)} />
                                        </td>
                                        {
                                            props.route == "shipping" &&
                                            <td>
                                                <input checked={item.chosen} onChange={() => handleChooseAddress(item)} id="check-boxes" type="checkbox" />
                                            </td>
                                        }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                        {
                            savedAddress &&
                            savedAddress.length == 0 &&
                            <h2 className="no-address-title">آدرسی ذخیره نکرده اید</h2>
                        }
            </div>
            <Accordion>
                <Accordion.Panel header="تایین آدرس" defaultExpanded>
                    <div id="adres" className="shipping-container-panel open">
                        <span className="info-part">مشخصات شهر</span>
                        <div className="state-city">
                            <div className="state">
                                <label>استان : *</label>
                                <div className={showState ? "select open" : "select"}>
                                    <div className="selected-option" onClick={() => setShowState(!showState)}>
                                        <span>{address.state.placeHolder}</span>
                                        <span><AiOutlineDown /></span>
                                    </div>
                                    <div className="select-container">
                                        <div className="search-option">
                                            <input type="text" placeholder="جستجو..." value={searchState} onChange={e => setSearchState(e.target.value)} />
                                        </div>
                                        <ul>
                                            {stateOptions.map((item, i) => {
                                                return (
                                                    <li onClick={() => {
                                                        setState(item)
                                                        setShowState(false)
                                                        setSearchState("")
                                                        setCity("انتخاب شهر")
                                                    }} key={i}>{item.placeHolder}</li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="city">
                                <label>شهر : *</label>
                                <div className={showCity ? "select open" : "select"}>
                                    <div className="selected-option" onClick={() => setShowCity(!showCity)}>
                                        <span>{address.city}</span>
                                        <span><AiOutlineDown /></span>
                                    </div>
                                    <div className="select-container">
                                        <div className="search-option">
                                            <input type="text" placeholder="جستجو..." value={searchCity} onChange={e => setSearchCity(e.target.value)} />
                                        </div>
                                        <ul>
                                            {cityoptions.map((item, i) => {
                                                return (
                                                    <li onClick={() => {
                                                        setCity(item)
                                                        setShowCity(false)
                                                        setSearchCity("")
                                                    }} key={i}>{item}</li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className="info-part">مشخصات منزل</span>
                        <div className="location">
                            <span>آدرس : * </span>
                            <textarea onChange={(e) => setAddress({ ...address, address: e.target.value })} value={address.address} name="address" className="inp-location" placeholder="مثال : طبرسی شمالی 38 طباطبایی 4 داخل سه راه دوم" minLength={1} maxLength={100}></textarea>
                        </div>
                        <div className="postalcode">
                            <div className="inp-postalcode">
                                <label>کدپستی : * </label>
                                <input onChange={(e) => setAddress({ ...address, postCode: e.target.value })} value={address.postCode} type="text" placeholder="1234567890" />
                            </div>
                            <div className="house-number">
                                <label>پلاک : *</label>
                                <input onChange={(e) => setAddress({ ...address, number: e.target.value })} value={address.number} type="text" placeholder="131" />
                            </div>
                            <div className="staire">
                                <label>طبقه : *</label>
                                <input onChange={(e) => setAddress({ ...address, floor: e.target.value })} value={address.floor} type="text" placeholder="همکف" />
                            </div>
                        </div>
                        <span className="info-part">مشخصات تحویل گیرنده</span>
                        <div className="transfree">
                            <div className="inp-postalcode">
                                <label>نام : * </label>
                                <input onChange={(e) => setAddress({ ...address, transfreeFname: e.target.value })} value={address.transfreeFname} type="text" placeholder="سبحان" />
                            </div>
                            <div className="house-number">
                                <label>نام خانوادگی : *</label>
                                <input onChange={(e) => setAddress({ ...address, transfreeLname: e.target.value })} value={address.transfreeLname} type="text" placeholder="سفیدکار" />
                            </div>
                            <div className="staire">
                                <label>شماره تماس : *</label>
                                <input onChange={(e) => setAddress({ ...address, transfreePhoneNumber: e.target.value })} value={address.transfreePhoneNumber} type="text" placeholder="09012345678" />
                            </div>
                        </div>
                        {
                            selectedAddress &&
                            <>
                                <button onClick={() => {
                                    setSelectedAddress(false)
                                    setAddress(
                                        {
                                            state: { placeHolder: "خراسان رضوی", value: "khorasanRazavi" },
                                            city,
                                            address: "",
                                            postCode: "",
                                            number: "",
                                            floor: "",
                                            transfreeFname: "",
                                            transfreeLname: "",
                                            transfreePhoneNumber: "",
                                            chosen: false
                                        }
                                    )
                                }} className="cancel">کنسل</button>
                                <button onClick={() => updateAddress()}>بروزرسانی</button>
                            </>
                        }
                        {
                            selectedAddress == false &&
                            <button onClick={() => handleAddress()}>ثبت آدرس</button>
                        }
                    </div>
                </Accordion.Panel>
            </Accordion>

        </div>
    )
}

export default ProfileAdd;